import { apiClient } from 'src/lib/apiClient';

export interface DigitalFlyer {
  id: number;
  merchant: {
    id: number;
    name: string;
  };
  message: string;
  status: 'PENDING' | 'AWAITING_APPROVAL' | 'APPROVED' | 'REJECTED' | 'READY_TO_SEND';
  date_created: string;
  cost: number;
  rejection_message?: string;
}

const DIGITAL_FLYERS_URL = 'digital-flyers';

export const digitalFlyersApi = {
  getAllFlyers: async (status?: DigitalFlyer['status']): Promise<DigitalFlyer[]> => {
    const response = await apiClient.get(DIGITAL_FLYERS_URL, {
      params: status ? { status } : undefined
    });
    return response.data;
  },

  createFlyer: async (merchantId: number, userId: number, message: string, cost: number, isFree?: boolean): Promise<DigitalFlyer> => {
    const response = await apiClient.post(DIGITAL_FLYERS_URL, {
      merchantId,
      userId,
      message,
      cost,
      ...(isFree !== undefined && { isFree })
    });
    return response.data;
  },

  getFlyersByMerchant: async (merchantId: number): Promise<DigitalFlyer[]> => {
    const response = await apiClient.get(`${DIGITAL_FLYERS_URL}/merchant/${merchantId}`);
    return response.data;
  },

  approveFlyer: async (flyerId: number): Promise<void> => {
    await apiClient.post(`${DIGITAL_FLYERS_URL}/${flyerId}/approve`);
  },

  rejectFlyer: async (flyerId: number, rejectionMessage: string): Promise<void> => {
    await apiClient.post(`${DIGITAL_FLYERS_URL}/${flyerId}/reject`, {
      rejectionMessage
    });
  },

  editFlyer: async (flyerId: number, message: string): Promise<DigitalFlyer> => {
    const response = await apiClient.put(`${DIGITAL_FLYERS_URL}/${flyerId}`, {
      message
    });
    return response.data;
  },

  sendFlyer: async (flyerId: number): Promise<void> => {
    await apiClient.post(`${DIGITAL_FLYERS_URL}/${flyerId}/send`);
  },

  deleteFlyer: async (flyerId: number): Promise<void> => {
    await apiClient.delete(`${DIGITAL_FLYERS_URL}/${flyerId}`);
  }
}; 